import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Layout from 'eventbrite_design_system/layout/Layout';
import { withEventSaveNotification } from '@eb/destination-utils';
import {
    SiteStructure,
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
} from '@eb/site-structure';
import FeaturedOrganizerSection from '../components/FeaturedOrganizerSection';
import BrowseMoreButton from '../components/BrowseMoreButton';

export default class Page extends PureComponent {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
        footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
        children: PropTypes.node,

        isLoading: PropTypes.bool,
    };

    state = {
        organizerIds: [],
    };

    componentDidMount() {
        const { organizerIds } = this.props;

        // Until we configure how to pass additional
        // IDs to add follow as we receive them, keeping
        // organizer IDs in state to ensure subsequent
        // page GETs don't trigger additional organizers
        // to be passed down to addFollow
        this.setState({ organizerIds });
    }

    render() {
        const {
            env,
            request,
            user,
            footerLinks,
            children,
            isLoading,

            userId,
            gaSettings,
            gaCategory,
            isAuthenticated,
            handleClickBrowseEvents,
            showFeaturedOrganizers,
        } = this.props;

        const { organizerIds } = this.state;

        const featuredOrganizerSectionNode = (
            <FeaturedOrganizerSection
                userId={userId}
                organizerIds={organizerIds}
                gaSettings={gaSettings}
                gaCategory={gaCategory}
                isAuthenticated={isAuthenticated}
            />
        );

        const browseMoreButtonNode = (
            <BrowseMoreButton
                handleClickBrowseEvents={handleClickBrowseEvents}
                showFeaturedOrganizers={showFeaturedOrganizers}
            />
        );

        return (
            <SiteStructure
                env={env}
                request={request}
                user={user}
                footerLinks={footerLinks}
                isLoading={isLoading}
                fullScreenMain={true}
            >
                {children}
                <Layout maxWidth="large" hasHorizontalGutters={true}>
                    {showFeaturedOrganizers && featuredOrganizerSectionNode}
                    {browseMoreButtonNode}
                </Layout>
            </SiteStructure>
        );
    }
}
